import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import {
  SalesCenterForm,
  SalesCenterRules,
  SalesCenterLayout,
  SalesCenterWorkflow,
  SalesCenterApiContainer,
} from 'modules/dealSheet';

export const SalesCenterConfiguration = () => (
  <CardContainer style={{ padding: '0.5rem' }}>
    <SalesCenterApiContainer>
      {({ listOfConfigs, config, onConfigureWorkflow, isLoading }) => (
        <SalesCenterLayout
          form={<SalesCenterForm />}
          rules={<SalesCenterRules workflow={config} />}
          workflow={
            <SalesCenterWorkflow
              isLoading={isLoading}
              listOfWorkflow={listOfConfigs}
              onConfigureWorkflow={onConfigureWorkflow}
            />
          }
        />
      )}
    </SalesCenterApiContainer>
  </CardContainer>
);
